/** The host part of an event request: the chosen profile, or nothing so the server picks it. */
export function hostPayload(hostProfileId: string | null | undefined): {
  hostProfileId?: string
} {
  return hostProfileId ? { hostProfileId } : {}
}
